import React from "react";
import { Col, Row } from "reactstrap";
import { getLoggedinUser } from "../../helpers/api_helper";

const Section = () => {
  const user = getLoggedinUser();
  const name = user?.username ?? user?.name ?? user?.email ?? "there";
  const greeting =
    new Date().getHours() < 12 ? "Good Morning" : new Date().getHours() < 18 ? "Good Afternoon" : "Good Evening";

  return (
    <React.Fragment>
      <Row className="mb-3 pb-1">
        <Col xs={12}>
          <div className="d-flex align-items-lg-center flex-lg-row flex-column">
            <div className="flex-grow-1">
              <h4 className="fs-16 mb-1">
                {greeting}, {name}!
              </h4>
              <p className="text-muted mb-0">Here&apos;s what&apos;s happening with your store today.</p>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Section;
